export default __webpack_public_path__ + "static/media/blacklist.7967b3a3.svg";